import { render, staticRenderFns } from "./BeforeDel.vue?vue&type=template&id=73b54a7c&scoped=true"
import script from "./BeforeDel.vue?vue&type=script&lang=js"
export * from "./BeforeDel.vue?vue&type=script&lang=js"
import style0 from "./BeforeDel.vue?vue&type=style&index=0&id=73b54a7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b54a7c",
  null
  
)

export default component.exports